import { z } from 'zod';
import { ProductClassifications, ProductOptions, ProductPromotions } from '@mews-commander/data-access';
import { CustomErrorParams, CustomErrorType, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const commonOptionSchema = z.object({
    promotions: Validation.Flag.Default<ProductPromotions>([
        'afterCheckIn',
        'afterCheckOut',
        'beforeCheckIn',
        'beforeCheckOut',
        'duringCheckOut',
        'duringStay',
    ]).nullish(),
    options: Validation.Flag.Default<ProductOptions>([
        'billAsPackage',
        'offerToCustomer',
        'excludePriceFromOffer',
        'offerToEmployee',
        'createTask',
        'proRataCharging',
        'selectedByDefault',
    ]),
});

export const productOptionsSchema = commonOptionSchema.extend({
    classifications: Validation.Flag.Default<ProductClassifications>([
        'beverage',
        'cityTax',
        'food',
        'wellness',
        'fee',
    ]).nullish(),
});

export const allowanceOptionsSchema = commonOptionSchema.extend({
    permittedAccountingCategoryIds: z.array(z.string()).superRefine((permittedAccountingCategoryIds, ctx) => {
        if (permittedAccountingCategoryIds.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                params: {
                    errorType: CustomErrorType.Other,
                    textKey: TextKey.AllowanceFormAccountingTreeErrorMessage,
                } satisfies CustomErrorParams,
                fatal: true,
            });
        }
    }),
});
